<template>
  <div id="main-content" class="error-pages">
    <router-view />
  </div>
</template>

<script>
/**
 * Unlike most other views, error page require this as each error pages are public website SFC and is not wrapped by wrapper with #main-content which is needed in this case
 */
</script>
